import AdminRouter from "@/@admin/router";
import { $api, RouterUtilClass } from "@/shared";
import { Business, User } from "@/shared/interfaces";
import { ApiResourceResult } from "@/shared/vuex";
import { StoreOptions } from "vuex";

export interface AdminBusinessesVuexState extends ApiResourceResult<User> {
  businesses?: Business[];
  loading: boolean;
}

export const AdminBusinessesVuex: StoreOptions<AdminBusinessesVuexState> = {
  ...{ namespaced: true },
  state: {
    businesses: undefined,
    loading: false,
  },
  mutations: {},
  actions: {
    /**
     * Fetches users
     * @param context
     */
    fetch(context) {
      context.state.loading = true;
      $api.admin
        .get<ApiResourceResult<Business>>(
          `/v1/admin-businesses?${RouterUtilClass.extractQuery(AdminRouter)}`
        )
        .then(({data}) => {
          context.state.count = data.count;
          context.state.next = data.next;
          context.state.skipped = data.skipped;
          context.state.businesses = data.resources;
          //   Vue.set
        })
        .finally(() => {
          context.state.loading = false;
        });
    },
  },
  modules: {},
  //
  getters: {},
};
